import { Component, OnInit } from '@angular/core';
import { UserLogin } from '../../../models/user-login.model';
import { AlertService, MessageSeverity, DialogType } from '../../../services/alert.service';
import { AccountService } from "../../../services/account.service";
import { RouterLink } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterLink
  ]
})
export class ResetPasswordComponent implements OnInit {

  userLogin = new UserLogin();
  userEmail: string = "";

  constructor(private alertService: AlertService, private accountService: AccountService) {
  }

  ngOnInit() {
  }

  showErrorAlert(caption: string, message: string) {
    this.alertService.showMessage(caption, message, MessageSeverity.error);
  }

  resetPassword() {
    console.log('Reset clicked');

    this.alertService.startLoadingMessage("Saving changes...");

    this.accountService.resetUserPassword(this.userEmail)
      .subscribe({ next: user => {


        this.alertService.showMessage("Success", "Please check your email for further action.", MessageSeverity.success);

        this.alertService.stopLoadingMessage();
      }
        , error: (error) => {
          this.alertService.stopLoadingMessage();
          this.alertService.showStickyMessage("Save Error", "The below errors occured whilst saving your changes:", MessageSeverity.error, error);
          this.alertService.showStickyMessage(error, null, MessageSeverity.error);
        }
      });
  }

}
